const powerballTemplate = require('./game.powerball.handlebars');
const megamillionsTemplate = require('./game.megamillions.handlebars');
const bankamillionTemplate = require('./game.bankamillion.handlebars');
const pick3Template = require('./game.pick3.handlebars');
const pick4Template = require('./game.pick4.handlebars');
const cash5Template = require('./game.cash5.handlebars');
const cash4lifeTemplate = require('./game.cash4life.handlebars');
const kenoTemplate = require('./game.keno.handlebars');
const raffleTemplate = require('./game.raffle.handlebars');
const noSelectionTemplate = require('./game.noselection.handlebars');
const GAMES_LIST = require('../../shared/scripts/GAMES_LIST').default;
const DATE_RANGE_OPTIONS = require('./DATE_RANGE_OPTIONS').default;
const KENO_DRAWS_RANGE_OPTIONS = require('./KENO_DRAWS_RANGE_OPTIONS').default;
const EnableAutoTab=require('../../shared/scripts/EnableAutoTab');
var initialGameId;
$(function () {	
    if (!$('#homepage-check-my-numbers-container').length) return;

    //INIT
    
    if ($('#checknumbers-gameid').length) {
        initialGameId = $('#checknumbers-gameid').val();
    }

    if (initialGameId=='0'){        
        initializeGameSelector();
        //initializeDateRangeSelector();
    } 
    else {
       $('.game-selector').addClass('hidden');
       $('#homepage-check-my-numbers-container').find('.link-container').parent().addClass('hidden');
       initializeGameSelector(initialGameId);
       showMatchOrderDropdown(initialGameId);
       console.log('gameid is:-'+(initialGameId=='30'));
      // if(gameId=='30'){
      //     initializeKenoDrawsRangeSelector();
      // }
      // else{
       //initializeDateRangeSelector(initialGameId);
      // }
       initializeValidation();   
       //setInputFocus();
    }
    initializeDateRangeSelector(initialGameId);

    //EVENTS
    $('#btn-check-my-numbers').on('click', function (e) {
        e.preventDefault();
        let formId = 'checknumberform';

        //set Form input values
        setHiddenFormInputValues(formId);        
        //location.href="http://newredesign.valottery.com/checkmynumbers";
        let gameId = parseInt(document.getElementById('checknumberform_gameId').value);
        location.href=GAMES_LIST.find(item => item.Id === gameId).CheckMyNumbersTab;
        /*setFormSubmitAction(formId, gameId);
        //submit form
		 setTimeout(function() { 
       document.getElementById(formId).submit()
    }, 2000);*/
       
    });

    $(".game-selector .dropdown-menu li").on('click', function () {
       let gameId=$(this).data('game-id');
       // if(gameId=='30'){
       //    initializeKenoDrawsRangeSelector();
       //}else{initializeDateRangeSelector();}
       initializeDateRangeSelector(gameId);
        setDropdownSelection(this, 'game-id');
        updateNumberInputDisplay(this);
        initializeValidation();
        setInputFocus();
        showMatchOrderDropdown(gameId);
    });

    $(".date-range-selector .dropdown-menu li").on('click', function () {
        console.log('hello');
        setDropdownSelection(this, 'date-range-id');
    });
})

function initializeDateRangeSelector(gameId) {
    let $container=$('#homepage-check-my-numbers-container');
    let $inputContainer=$container.find('#play-inputs').parent();
    let $ddlContainer= $container.find('.date-range-selector');
    const $dateRangeDropdownMenu = $ddlContainer.find('#dd-date-range');
    const $dateRangeLabel = $ddlContainer.find('label');
    let $inputLabel=$inputContainer.find('.number-input-title strong');
    let $btnChecknum=$container.find('#btn-check-my-numbers');
    //const $dateRangeDropdownMenu = $('#homepage-check-my-numbers-container .date-range-selector #dd-date-range');
    //const $dateRangeLabel = $('#homepage-check-my-numbers-container .date-range-selector label');
    $dateRangeDropdownMenu.html('');
    /*DATE_RANGE_OPTIONS.forEach((value) =>
        $dateRangeDropdownMenu.append(`<li data-date-range-id="${value.Id}">${value.Title}</li>`));

    //Default to 'last 7 days'
    const $defaultOption = $dateRangeDropdownMenu.children('li[data-date-range-id="2"]');
    setDropdownSelection($defaultOption, 'date-range-id');
    */
   console.log('gameid is:-'+(initialGameId + ' - '+gameId));
    (gameId=='30'?KENO_DRAWS_RANGE_OPTIONS:DATE_RANGE_OPTIONS).forEach((value) =>
     $dateRangeDropdownMenu.append(`<option value="${value.Value}">${value.Title}</option>`));
     $dateRangeDropdownMenu.val(gameId=='30'?1:7); 
     if(initialGameId=='30'){
        $container.find('green-3-text').css('font-size','18px');
        $inputContainer.html('<center>'+$inputContainer.html()+'</center>');
        $ddlContainer.wrap('<center></center>');
        $btnChecknum.wrap('<center></center>');
    }
     if(gameId=='30') {
          $container.find('#play-inputs').css('display','block');
          $dateRangeLabel.show(); 
          $inputLabel.html('Enter Your Draw Number:');
          $btnChecknum.html('CHECK MY DRAW');
        }
     else{ 
        $container.find('#play-inputs').css('display','flex');
        $dateRangeLabel.hide(); 
        $inputLabel.html('enter your numbers');
        $btnChecknum.html('CHECK MY NUMBERS');
    }
};

/*function initializeKenoDrawsRangeSelector() {
    const $kenoDrawRangeDropdownMenu = $('.date-range-selector .dropdown-menu');
    $kenoDrawRangeDropdownMenu.html('');
    KENO_DRAWS_RANGE_OPTIONS.forEach((value) =>
        $kenoDrawRangeDropdownMenu.append(`<li data-date-range-id="${value.Id}">${value.Title}</li>`));

    const $defaultOption = $kenoDrawRangeDropdownMenu.children('li[data-date-range-id="1"]');
    setDropdownSelection($defaultOption, 'date-range-id');
};*/
function initializeGameSelector(gameId) {
    const $gameDropdownMenu = $('.game-selector .dropdown-menu');
    let $selectedOption;

    GAMES_LIST.forEach((value) =>
        $gameDropdownMenu.append(`<li data-game-id="${value.Id}">${value.Title}</li>`));

    if (!gameId) {
        //Default to first option in list
        $selectedOption = $gameDropdownMenu.children().first();
    } else {
        $selectedOption = $gameDropdownMenu.children(`[data-game-id=${gameId}]`);
    }
    updateNumberInputDisplay($selectedOption);
    setDropdownSelection($selectedOption, 'game-id');

    initializeValidation();
}

function setDropdownSelection(selectedItem, dataName) {
    const $selectedItem = $(selectedItem);
    const $dropdown = $selectedItem.parents('.dropdown');
    console.log('selected item '+dataName+' selected val '+$selectedItem.data(dataName));
    $dropdown.find('.btn .dropdown-display').html($selectedItem.text());
    $dropdown.find('.btn').val($selectedItem.data(dataName));    
}

function updateNumberInputDisplay(selectedItem) {
    const selectedGameId = $(selectedItem).data('game-id');
    const selectedGame = GAMES_LIST.find(item => item.Id === selectedGameId);
    let html = buildGameInputHtml(selectedGameId, selectedGame);

    $('#homepage-check-my-numbers-container .number-input-container').html(html);

    //Set URL for viewing all past numbers for the selected draw game
    let scrolltopastnumbersurl = `${selectedGame.DrawGamePageUrl}?scrollto=pastnumbers`;
    document.getElementById("all-past-numbers-link").href = scrolltopastnumbersurl;

};

function buildGameInputHtml(gameId, gameData) {
    switch (gameId) {
        case 20:
            return powerballTemplate(gameData)
            break;
        case 15:
            return megamillionsTemplate(gameData)
            break;
        case 1070:
            return bankamillionTemplate(gameData)
            break;
        case 1050:
            return pick3Template(gameData)
            break;
        case 1040:
            return pick4Template(gameData)
            break;
        case 1030:
            return cash5Template(gameData)
            break;
        case 1065:
            return cash4lifeTemplate(gameData)
            break;
        case 30:
            return kenoTemplate(gameData)
            break;
        case 7:
            return raffleTemplate(gameData)
            break;
        default:
            return noSelectionTemplate()
            break;
    }
};

function setInputFocus() {
    const firstInput = $('#homepage-check-my-numbers-container .number-input-container .number-input').first().find('input');
    firstInput.focus();
}

function initializeValidation() {
      $("#homepage-check-my-numbers-container .number-input input.numeric-only").on("keypress",function (event) {    
        var key=window.event ? event.keyCode : event.which;
		let gameId = $('.game-selector > #ddGameSelectorLabel').val();
		//console.log('gameId-'+gameId+'key press-'+key);
		if(gameId==1040 || gameId==1050)
        {
            if ((key==8 || key==9 || key==46)||(key >=48 && key <= 57))
            return true;            
        }
        else{
           if ((key==8 || key==9 || key==46)||(key >=48 && key <= 57))
		   {
			   if(key!==48)return true;
			   if(key===48&&$(this).val()>0)return true;
	       }           
        } 
 return false; 		   
        });	 
   //TO VALIDATE NUMBER INPUTS BY GAMES
   //Increased Cash 5 input number from 34 to 41
    $("#homepage-check-my-numbers-container .number-input input.numeric-only").on("keyup",function (event) {    
        var value=$(this).val();		   
        var parentClass=$(this).parent().attr('class');		  

        var maxNum=(parentClass.indexOf('keno-normal')>0?99999999:parentClass.indexOf('powerball-normal')>0?69:parentClass.indexOf('powerball-bonus')>0?26:parentClass.indexOf('megamillions-normal')>0?70:parentClass.indexOf('megamillions-bonus')>0?25:parentClass.indexOf('bankamillion-normal')>0?40:parentClass.indexOf('cash4life-normal')>0?60:parentClass.indexOf('cash4life-bonus')>0?4:41);		  
        // console.log('value-'+value+'parentClass-'+parentClass+'Max Num-'+maxNum);
        if(value>maxNum || value<0){
          $(this).val('');
        }          
        if(parentClass.indexOf('keno-normal')<=0){
            EnableAutoTab($(this),0); 			          
        }
    });	
}
function showMatchOrderDropdown(gameId) {
    //TODO: extend GAMES_LIST into a service with helper functions.. (ex. getPowerballId(), getGameById(20))
    //TODO: Remove hardcoded Ids from here..

    //only display this dropdown if pick3(id=1050) or pick4(id=1040)
    let isPick3OrPick4 = gameId == '1050' || gameId == '1040';
    console.log('game is loaded for '+gameId+' and match order: '+isPick3OrPick4);
    if (isPick3OrPick4) {
        $('#homepage-check-my-numbers-container .match-order-filter-container').removeClass('hidden');
        $('#homepage-check-my-numbers-container .match-order-filter-container').prev().addClass('col-sm-6');
    }
    else{
        $('#homepage-check-my-numbers-container .match-order-filter-container').prev().removeClass('col-sm-6');
        $('#homepage-check-my-numbers-container .match-order-filter-container').addClass('hidden');
    }
}

function setHiddenFormInputValues(formId) {
    let data = getUserEnteredValues();

    $(`#${formId} #checknumberform_gameId`).val(data.gameId);
    $(`#${formId} #checknumberform_numbersAsString`).val(data.numbersAsString);
    $(`#${formId} #checknumberform_bonusBall`).val(data.bonusBall);
    $(`#${formId} #checknumberform_dateRangeDays`).val(data.dateRangeDays);
    sessionStorage.chkNumGameId= data.gameId;
    sessionStorage.chkNumNumbersAsString=data.numbersAsString;
    sessionStorage.chkNumBonusBall=data.bonusBall;
    sessionStorage.chkNumDateRangeDays=data.dateRangeDays;
    sessionStorage.chkNumMatchOrder=data.matchOrder; 
}
function setFormSubmitAction(formId, selectedGameId) {
    let form = document.getElementById(formId);
    //form.action = GAMES_LIST.find(item => item.Id === selectedGameId).CheckNumbersPageUrl;
    form.action = GAMES_LIST.find(item => item.Id === selectedGameId).CheckMyNumbersTab;
}

function getUserEnteredValues() {
    let gameId = $('.game-selector > #ddGameSelectorLabel').val();
    //let dateRangeId = $('.date-range-selector > #ddDateRangeSelectorLabel').val();
    let dateRangeDaysValue = $('#homepage-check-my-numbers-container .date-range-selector #dd-date-range').val();
    console.log('dateRangeDaysValue '+dateRangeDaysValue);
    //DATE_RANGE_OPTIONS.find(item => item.Id === parseInt(dateRangeId)).Value;
    let playNumbers = $('[id=play-inputs]');
    let normalNumbers = playNumbers.children('.number-input:not(.bonus-ball)');
    let bonusBallValue = playNumbers.children('.number-input.bonus-ball').children('input').val();
    let numbers = [];
    let matchOrderVal = $('#homepage-check-my-numbers-container .match-order-filter-container select').val();

    $.each(normalNumbers, function (index, value) {
        numbers.push($(value).children('input').val());
    });

    return {
        gameId: parseInt(gameId),
        dateRangeDays: parseInt(dateRangeDaysValue),
        numbers: numbers,
        numbersAsString: numbers.join(","),
        bonusBall: bonusBallValue ? bonusBallValue : null,
        matchOrder: matchOrderVal
    };
}



// WEBPACK FOOTER //
// ./features/check-my-numbers/check-my-numbers.js